import { SETTING, MusicWebsite, DialingMode, OutreachModalOnClickSetting, NumberRotationStrategy } from 'interfaces/settings';

export interface SelectOption {
    value: string;
    label: string;
}

export interface SelectConfig {
    options: SelectOption[];
    defaultValue: string;
}

export const SELECT_SETTING_CONFIGS: { [K in SETTING]?: SelectConfig } = {
    [SETTING.MUSIC_WEBSITE]: {
        options: [
            { value: MusicWebsite.SPOTIFY, label: 'Spotify' },
            { value: MusicWebsite.YOUTUBE, label: 'YouTube' },
        ],
        defaultValue: MusicWebsite.SPOTIFY,
    },
    [SETTING.DIALING_MODE]: {
        options: [
            { value: DialingMode.SINGLE_NUMBER_ATTEMPT, label: 'Only try 1 # for contact' },
            { value: DialingMode.MULTI_NUMBER_ATTEMPT, label: 'Try all #s for contact until pickup' },
        ],
        defaultValue: DialingMode.MULTI_NUMBER_ATTEMPT,
    },
    [SETTING.OUTREACH_MODAL_CLICK_SETTING]: {
        options: [
            { value: OutreachModalOnClickSetting.RECORD_ALWAYS, label: 'Record Always' },
            { value: OutreachModalOnClickSetting.RECORD_ONE_PARTY, label: 'Record One Party' },
        ],
        defaultValue: OutreachModalOnClickSetting.RECORD_ONE_PARTY,
    },
    [SETTING.DEFAULT_NUMBER_ROTATION_STRATEGY]: {
        options: [
            { value: NumberRotationStrategy.GEOGRAPHICALLY_CLOSEST, label: 'Geographically Closest' },
            { value: NumberRotationStrategy.AUTO_ROTATE, label: 'Auto Rotate' },
        ],
        defaultValue: NumberRotationStrategy.GEOGRAPHICALLY_CLOSEST,
    },
};

export function getSelectConfig(setting: SETTING): SelectConfig {
    const config = SELECT_SETTING_CONFIGS[setting];
    if (!config) {
        throw new Error(`No select configuration found for setting: ${setting}`);
    }
    return config;
} 